export const isValidHexColor = (color) => /^#[0-9A-F]{6}$/i.test(color)
